// extracted by mini-css-extract-plugin
module.exports = {"summary":"_34Qsj","container":"pTPvp","info":"_4DlzX","title":"_14d8o","expandButton":"_2gTn8","tickets":"_3ez71","expanded":"_1OiLf"};